import React, { useContext, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";

import PopupTools from "../Popup/PopupTools";
import PopupToolsMobile from "../Popup/PopupToolsMobile";

import MobileContext from "../../contexts/Mobile/MobileContext";

function Popup(props) {
  const { isMobile } = useContext(MobileContext);

  const { open, imageData, handleClose, handleShowUploadDialog } = props;

  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    const zoomModifier = isMobile ? 0.5 : 0.2;

    setZoom(zoom + zoomModifier);
  };

  const handleZoomOut = () => {
    const zoomModifier = isMobile ? 0.5 : 0.2;

    setZoom(zoom - zoomModifier);
  };

  const handleResetZoom = () => {
    setZoom(1);
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      <img
        src={imageData.file}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "scale-down",
          transform: `scale(${zoom})`,
          transformOrigin: "0 0",
        }}
      />
      {isMobile && (
        <PopupToolsMobile
          zoom={zoom}
          imageData={imageData}
          handleResetZoom={handleResetZoom}
          handleZoomIn={handleZoomIn}
          handleZoomOut={handleZoomOut}
          handleClose={handleClose}
          handleShowUploadDialog={handleShowUploadDialog}
        />
      )}
      {!isMobile && (
        <PopupTools
          zoom={zoom}
          imageData={imageData}
          handleResetZoom={handleResetZoom}
          handleZoomIn={handleZoomIn}
          handleZoomOut={handleZoomOut}
          handleClose={handleClose}
          handleShowUploadDialog={handleShowUploadDialog}
        />
      )}
    </div>
  );
}

export default Popup;
